export default __webpack_public_path__ + "static/media/Container.403f6c61.png";